module.exports = __webpack_public_path__ + "img/bnr_quest@2x.026ba404.png";